export default __webpack_public_path__ + "static/media/xbox-1.755487db.png";